import { __rest } from "tslib";
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import classnames from 'classnames';
import { apiHolder, apis, api, SystemAccounts } from 'api';
import { ReactComponent as IconClose } from '@/images/icons/mail/icon-close1.svg';
import React, { useEffect, useState, useMemo } from 'react';
import styles from './sender.priority.module.scss';
import { Select } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { contactApi } from '@web-common/components/util/contact';
import Alert from '@web-common/components/UI/Alert/Alert';
import { RiskReminder } from '@web-mail/components/RiskReminder/risk-reminder';
import { getIn18Text } from 'api';
const trackerApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailManagerApi = apiHolder.api.requireLogicalApi('mailConfApiImpl');
const mailStrangerApi = apiHolder.api.requireLogicalApi(apis.mailStrangerApiImpl);
const storeApi = api.getDataStoreApi();
const sysApi = api.getSystemApi();
const eventApi = api.getEventApi();
export function setReadMailPriorityTipDsiable() {
    storeApi.putSync(ReadMailPriorityTipStoreKey, 'true');
}
var EnumSenderPriority;
(function (EnumSenderPriority) {
    EnumSenderPriority[EnumSenderPriority["HIGH"] = 0] = "HIGH";
    EnumSenderPriority[EnumSenderPriority["NORMAL"] = 1] = "NORMAL";
    EnumSenderPriority[EnumSenderPriority["LOW"] = 2] = "LOW";
    EnumSenderPriority[EnumSenderPriority["NONE"] = -1] = "NONE";
})(EnumSenderPriority || (EnumSenderPriority = {}));
export const SenderPriorityMap = {
    [EnumSenderPriority.NONE]: getIn18Text('WEIBIAOJI'),
    [EnumSenderPriority.LOW]: getIn18Text('DIYOU'),
    [EnumSenderPriority.HIGH]: getIn18Text('GAOYOU'),
    [EnumSenderPriority.NORMAL]: getIn18Text('PUTONG'),
};
export const ReadMailPriorityTipStoreKey = 'read_mail_priority_tip_show_disable';
const LowPriorityWarn = 'noMoreLowModal';
const isLowPriorityWarnClicked = () => {
    const res = storeApi.getSync(LowPriorityWarn);
    return res.suc && res.data === 'true';
};
const setLowPriorityWarnClicked = () => {
    storeApi.putSync(LowPriorityWarn, 'true');
};
const isSystemAccount = (email) => {
    return SystemAccounts.includes(email);
};
export const useContactPriority = (option, source) => {
    var _a;
    const { defaultPriority, user: { email, name, type }, } = option;
    const [priority, setPriority] = useState(defaultPriority);
    const [updating, setUpdating] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editable, setEditable] = useState(true);
    const disable = ((_a = sysApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) === email;
    const updatePriorityExcute = async (value) => {
        setUpdating(true);
        try {
            const res = await mailStrangerApi.setSmartPriorities({
                name,
                email,
                priority: value,
                prevPriority: priority,
            });
            res.success && setPriority(value);
        }
        catch (error) {
            console.error(error);
            SiriusMessage.error({ content: getIn18Text('SHEZHISHIBAI') });
        }
        setUpdating(false);
    };
    const updatePriority = async (v) => {
        const value = Number(v);
        const warnFlag = isLowPriorityWarnClicked();
        try {
            trackerApi.track('pc_low_priority_window', {
                page: source === 'contact_detail' ? getIn18Text('LIANXIRENXINXI11') : getIn18Text('YOUJIANXIANGQING'),
            });
        }
        catch (error) { }
        if (value === EnumSenderPriority.LOW && !warnFlag) {
            const al = Alert.warn({
                title: getIn18Text('QUEDINGYAOJIANGGAI'),
                content: getIn18Text('DIYOULIANXIREN11'),
                funcBtns: [
                    {
                        text: getIn18Text('QUXIAO'),
                        onClick: (_, nrm) => {
                            al.destroy();
                            try {
                                trackerApi.track('pc_low_priority_window_action', {
                                    select_no: nrm,
                                    follow_action: getIn18Text('QUXIAO'),
                                });
                            }
                            catch (error) { }
                        },
                    },
                    {
                        nmr: true,
                        onClick: (_, nmr) => {
                            nmr && setLowPriorityWarnClicked();
                            updatePriorityExcute(value);
                            al.destroy();
                            try {
                                trackerApi.track('pc_low_priority_window_action', {
                                    select_no: nmr,
                                    follow_action: getIn18Text('QUEDING'),
                                });
                            }
                            catch (error) { }
                        },
                        text: getIn18Text('QUEDING'),
                        type: 'primary',
                    },
                ],
            });
        }
        else {
            updatePriorityExcute(value);
        }
    };
    useEffect(() => {
        if (isSystemAccount(email)) {
            setPriority(EnumSenderPriority.HIGH);
            setEditable(false);
            return () => { };
        }
        const obId = eventApi.registerSysEventObserver('contactAccountNotify', {
            func: ({ eventStrData, eventData }) => {
                var _a;
                if (eventStrData === 'notify' && ((_a = eventData === null || eventData === void 0 ? void 0 : eventData.contact_personal) === null || _a === void 0 ? void 0 : _a.updateDiff)) {
                    contactApi.doGetContactById(eventData.contact_personal.updateDiff).then(datas => {
                        datas.forEach(data => {
                            var _a, _b, _c;
                            if (((_a = data === null || data === void 0 ? void 0 : data.contact) === null || _a === void 0 ? void 0 : _a.accountName) === email && ((_b = data === null || data === void 0 ? void 0 : data.contact) === null || _b === void 0 ? void 0 : _b.priority) !== priority) {
                                setPriority((_c = data === null || data === void 0 ? void 0 : data.contact) === null || _c === void 0 ? void 0 : _c.priority);
                            }
                        });
                    });
                }
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver('contactAccountNotify', obId);
        };
    }, []);
    useEffect(() => {
        if (isSystemAccount(email)) {
            setPriority(EnumSenderPriority.HIGH);
            setEditable(false);
            return () => { };
        }
        if (disable) {
            return () => { };
        }
        setLoading(true);
        mailStrangerApi
            .getSmartGetPriorities({
            email,
        })
            .then(res => {
            var _a;
            if (res.success) {
                if (((_a = res.data) === null || _a === void 0 ? void 0 : _a.priority) !== undefined) {
                    setPriority(res.data.priority);
                }
                else if (type === 'enterprise') {
                    setPriority(EnumSenderPriority.HIGH);
                }
                else {
                    setPriority(EnumSenderPriority.NONE);
                }
            }
        })
            .finally(() => {
            setLoading(false);
        });
        return () => { };
    }, [email, disable, type]);
    return {
        disable,
        priority,
        updatePriority,
        updating,
        loading,
        editable,
    };
};
const SenderPriorityTip = () => {
    const [priorityTipVisible, setPriorityTipVisible] = useState(false);
    const handleClose = () => {
        setReadMailPriorityTipDsiable();
        setPriorityTipVisible(false);
    };
    useEffect(() => {
        const store = storeApi.getSync(ReadMailPriorityTipStoreKey);
        if (store.data !== 'true') {
            setPriorityTipVisible(true);
        }
        return () => { };
    }, []);
    if (priorityTipVisible) {
        return (React.createElement("div", { className: classnames(styles.wrapper, styles.wrapperTip) },
            React.createElement("span", { className: styles.btnClose, onClick: handleClose },
                React.createElement(IconClose, null)),
            React.createElement("p", null,
                React.createElement("i", { className: styles.iconQuestion }),
                React.createElement("span", null, getIn18Text('XIANGRANGYOUJIANZHAN')))));
    }
    return null;
};
export const SenderPriority = props => {
    const { sender, defaultPriority, riskMinderOpen = false } = props;
    const { priority, updatePriority, disable, editable } = useContactPriority({ user: sender, defaultPriority });
    const [setPriorityVis, setSetPriorityVis] = useState(true);
    const [riskReminderVis, setRiskReminderVis] = useState(true);
    const isThreadMode = mailManagerApi.getMailMergeSettings() === 'true';
    const promptType = useMemo(() => {
        if (disable || !editable)
            return '';
        if (riskMinderOpen) {
            return 'riskMinder';
        }
        if (!isThreadMode) {
            if (priority === EnumSenderPriority.NONE) {
                return 'setPriority';
            }
            if (priority === EnumSenderPriority.LOW) {
                return 'changePriority';
            }
        }
        return '';
    }, [riskMinderOpen, priority, disable, editable]);
    const handleChangePriority = (value) => {
        updatePriority(value);
        try {
            trackerApi.track('pc_importance_of_sender', {
                mark_location: 'mail_detail',
                important: value,
            });
        }
        catch (error) {
            message.error(getIn18Text('SHEZHIYOUXIANJI'));
        }
    };
    const handleClose = () => {
        setSetPriorityVis(false);
    };
    if (promptType === 'riskMinder') {
        return riskReminderVis ? (React.createElement(RiskReminder, { _account: props._account, contactId: props.contactId, email: props.email, contact: props.contact, senderMail: sender.email, senderName: sender.name || '', visible: riskReminderVis, setVisible: setRiskReminderVis })) : (React.createElement(React.Fragment, null));
    }
    return null;
};
export const SenderPrioritySelect = (_a) => {
    var { sender, type = 'main', defaultPriority } = _a, rest = __rest(_a, ["sender", "type", "defaultPriority"]);
    const { priority, updatePriority, loading, disable, editable } = useContactPriority({ user: sender, defaultPriority }, 'contact_detail');
    if (priority === undefined || loading || disable) {
        return null;
    }
    return (React.createElement(Select, Object.assign({ size: type === 'main' ? 'small' : 'large', disabled: !editable, dropdownClassName: styles.selectDropdownWrap, className: classnames(styles.select, {
            [styles.selectMain]: type === 'main',
            [styles.selectTooltip]: type === 'tooltip',
            [styles.selectMainLow]: priority === EnumSenderPriority.LOW && type === 'main',
            [styles.selectMainNormal]: priority === EnumSenderPriority.NORMAL && type === 'main',
            [styles.selectMainHigh]: priority === EnumSenderPriority.HIGH && type === 'main',
        }), onChange: v => {
            try {
                trackerApi.track('pc_importance_of_sender', {
                    mark_location: 'mail_detail',
                    important: v,
                });
            }
            catch (error) { }
            updatePriority(v);
            setReadMailPriorityTipDsiable();
        }, suffixIcon: React.createElement("i", { className: type === 'main' ? styles.dropdown : styles.arrowdown }), value: priority === EnumSenderPriority.NONE ? SenderPriorityMap[priority] : priority, options: Object.entries(SenderPriorityMap)
            .filter(([value]) => Number(value) !== EnumSenderPriority.NONE)
            .map(([key, label]) => ({
            label,
            value: Number(key),
        })), placeholder: SenderPriorityMap[EnumSenderPriority.NONE] }, rest)));
};
